<template>
  <v-dialog v-model="visible" persistent max-width="600px" scrollable>
    <v-form ref="form" @submit.prevent="handleSubmit">
      <v-card :loading="loading">
        <v-card-title>
          <span class="headline">{{ $t("modal.addCaseGroup.title") }}</span>
        </v-card-title>
        <v-card-subtitle>
          {{ $t("modal.addCaseGroup.subtitle") }}
        </v-card-subtitle>

        <v-card-text>
          <v-container>
            <v-alert
              v-if="error"
              border="left"
              colored-border
              type="error"
              elevation="2"
            >
              {{ error }}
            </v-alert>

            <v-row >
              <!-- case group name -->
              <v-col cols="6">
                <v-text-field
                  :maxlength="20"
                  :label="$t('label.name')"
                  v-model="caseGroup.name"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  style="font-size: 1em"
                  label="Default Assignee"
                  clearable
                  v-model="caseGroup.defaultAssignedUser"
                  :items="users"
                  :item-text="(item) => {  return getTextForUserSelect(item); }"
                  return-object
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  style="font-size: 1em"
                  label="Receive Open Case Alerts"
                  multiple
                  v-model="caseGroup.alertUsers"
                  :items="users"
                  item-text="email"
                  return-object
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  :maxlength="75"
                  v-model="caseGroup.description"
                  :label="$t('label.description')"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="onCancel">{{
            $t("label.cancel")
          }}</v-btn>
          <v-btn color="primary" type="submit" :loading="loading">{{
            $t("label.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { getTextForUserSelect } from "../../utils/userUtils";
export default {
  name: "EditCaseGroup",
  props: {
    caseGroup: {},
    users: {},
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      error: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    ...mapActions(["updateCaseGroup", "setGlobalAlert"]),
    getTextForUserSelect,
    // submit
    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.error = null;
      this.loading = true;

      try {
        await this.updateCaseGroup(this.caseGroup);
        this.$emit("onClose");
        this.setGlobalAlert({
          alert: true,
          color: "green",
          alertMessage: "Case Group Updated",
        });
      } catch (e) {
        this.error = this.$t("error.general.unhandled");
      }

      this.loading = false;
      //this.$refs.form.reset();
    },

    onCancel() {
      //this.$refs.form.reset();
      this.$emit("onClose");
    },
  },
};
</script>